import { useEffect, useState } from "react"
import useAppStore from "store/app"

import SuccessStatus from "./Success"
import BadStatus from "./Bad"
import WarningStatus from "./Warning"
import NotInfo from "./NotInfo"
import { Link } from "react-router-dom"
import { Typography } from "@mui/material"
import { MAX_DISEASES } from "config/constants"
import useTranslation from "hooks/use_translation"

const CurrentCard = ({ symptoms, diseases }) => {
  const dangerMatches = symptoms.some((item) => item.danger === "high")
  const warningMatches = symptoms.some((item) => item.danger === "medium")

  if (dangerMatches) {
    return <BadStatus diseases={diseases} />
  } else if (warningMatches) {
    return <WarningStatus diseases={diseases} />
  } else {
    return <SuccessStatus diseases={diseases} />
  }
}

const HealthStatus = () => {
  const [anamnesis, setAnamnesis] = useState({})
  const getClientAnamneses = useAppStore((state) => state.getClientAnamneses)
  const { pages } = useTranslation()

  useEffect(() => {
    fetchLastScreening()
  }, [])

  const fetchLastScreening = () => {
    getClientAnamneses().then((response) => {
      const lastAnamneses = response.data[0]
      setAnamnesis(lastAnamneses || {})
    })
  }

  if ("symptoms" in anamnesis) {
    return (
      <>
        <CurrentCard
          symptoms={anamnesis.symptoms}
          diseases={anamnesis.possible_diseases.slice(0, MAX_DISEASES)}
        />
        <Link to="/me/last_screening">
          <Typography
            variant="body1"
            sx={{ textDecoration: "underline", color: "#fff", textAlign: "center", my: 1 }}
          >
            {pages?.client_main?.more_info}
          </Typography>
        </Link>
      </>
    )
  }

  return <NotInfo />
}

export default HealthStatus
